export interface ShareUrlOptions {
  url: string;
}

export type ShareUrlResult = 'shared' | 'copied' | 'cancelled';

export const shareUrl = async ({
  url
}: ShareUrlOptions): Promise<ShareUrlResult> => {
  if (navigator.share) {
    try {
      await navigator.share({ url });
      return 'shared';
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') {
        return 'cancelled';
      }
    }
  }

  if (!navigator.clipboard || !window.isSecureContext) {
    throw new Error('Clipboard API is not available');
  }

  await navigator.clipboard.writeText(url);
  return 'copied';
};
